export default "__VITE_ASSET__BO$Xw8nU__"